import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useTheme } from '../context/ThemeContext';
import './ToolPage.css';

export default function GuidedPlanner() {
  const iframeRef = useRef(null);
  const [iframeReady, setIframeReady] = useState(false);
  const { theme, fontSize } = useTheme();

  const syncSettings = useCallback(() => {
    iframeRef.current?.contentWindow?.postMessage(
      { type: 'SET_THEME', theme, fontSize },
      '*'
    );
  }, [theme, fontSize]);

  useEffect(() => {
    function handleMessage(event) {
      if (!event.data || typeof event.data !== 'object') return;
      if (event.data.type === 'PLANNER_READY') {
        setIframeReady(true);
        setTimeout(() => {
          iframeRef.current?.contentWindow?.postMessage(
            { type: 'SET_THEME', theme, fontSize },
            '*'
          );
        }, 50);
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [theme, fontSize]);

  useEffect(() => {
    if (!iframeReady) return;
    const iframe = iframeRef.current;
    if (!iframe?.contentWindow) return;
    syncSettings();
    try {
      const saved = localStorage.getItem('retirementPlannerSpending');
      if (saved) {
        iframe.contentWindow.postMessage(
          { type: 'LOAD_SPENDING', payload: JSON.parse(saved) },
          '*'
        );
      }
    } catch (e) {}
  }, [iframeReady, syncSettings]);

  // Push theme/fontSize whenever they change
  useEffect(() => {
    if (!iframeReady) return;
    syncSettings();
  }, [theme, fontSize, iframeReady, syncSettings]);

  return (
    <div className="tool-page">
      <div className="tool-toolbar">
        <div className="tool-toolbar-left">
          <h2 className="tool-title">Guided Retirement Planner</h2>
        </div>
      </div>

      <div className="tool-frame-wrapper">
        <iframe
          ref={iframeRef}
          src="/tools/guidedPlanner.html"
          title="Guided Canadian Retirement Planner"
          className="tool-iframe"
          sandbox="allow-scripts allow-same-origin allow-forms allow-downloads allow-modals"
        />
      </div>
    </div>
  );
}